import { render, staticRenderFns } from "./MainTableFive.vue?vue&type=template&id=388ce9cc&scoped=true&"
import script from "./MainTableFive.vue?vue&type=script&lang=js&"
export * from "./MainTableFive.vue?vue&type=script&lang=js&"
import style0 from "./MainTableFive.vue?vue&type=style&index=0&id=388ce9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ce9cc",
  null
  
)

export default component.exports